/**
 * Frontend entry — delegates to shared financial-core (compiled under functions/src/financial-core).
 */
import type { Expense, Revenue } from '../types/startup.types';
import {
  FinancialCalculationService as CoreService,
  type StandardizedCustomerData,
  type StandardizedExpense,
  type StandardizedRevenue,
  type CalculationResult,
  type AggregateCalculationResult,
} from '@burnchart/financial';

export type {
  StandardizedCustomerData,
  StandardizedExpense,
  StandardizedRevenue,
  CalculationResult,
  AggregateCalculationResult,
};

export class FinancialCalculationService extends CoreService {
  static standardizeExpense(expense: Expense): StandardizedExpense {
    return CoreService.standardizeExpenseFromAny(expense as unknown as Record<string, unknown>);
  }

  static standardizeRevenue(revenue: Revenue): StandardizedRevenue {
    return CoreService.standardizeRevenueFromAny(revenue as unknown as Record<string, unknown>);
  }
}

export {
  calculateExpenseAtMonth,
  calculateRevenueAtMonth,
  calculateMonthlyCustomerMetrics,
  calculateLTV,
  toStandardizedCustomerData,
  normalizeCustomerDataInput,
  getMonthsElapsed,
  startOfMonthUTC,
  calculateAssetValue,
  calculateAssetMonthlyImpact,
  calculateAssetPurchaseCashFlow,
  isOnOrAfterStartupStart,
  isStartupStartMonth,
  sumFundingEventsInMonth,
} from '@burnchart/financial';
